import { render } from "./BarCode.vue?vue&type=template&id=e7deec46"
import script from "./BarCode.vue?vue&type=script&lang=js"
export * from "./BarCode.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__